export type SubscriptionType = 'essential' | 'pro' | 'active-active' | 'dedicated' | 'free';

export const SUBSCRIPTION_TYPE = {
  ESSENTIAL: 'essential',
  PRO: 'pro',
  ACTIVE_ACTIVE: 'active-active',
  DEDICATED: 'dedicated'
} as const;

export const getType = (plan: Plan | undefined) => {
  if (!plan?.plan_type) {
    return undefined;
  }

  const planTypeMap: { [K in PlanType]: SubscriptionType } = {
    aarcp: SUBSCRIPTION_TYPE.ACTIVE_ACTIVE,
    rcp: SUBSCRIPTION_TYPE.PRO,
    dedicated: SUBSCRIPTION_TYPE.DEDICATED,
    paid: SUBSCRIPTION_TYPE.ESSENTIAL,
    free: SUBSCRIPTION_TYPE.ESSENTIAL,
    beta: SUBSCRIPTION_TYPE.ESSENTIAL,
    'aws-marketplace': SUBSCRIPTION_TYPE.ESSENTIAL
  };

  return planTypeMap[plan.plan_type];
};
